<template>
  <v-autocomplete
    label="Localidade"
    :items="localidades"
    item-text="descricao"
    item-value="codigo"
    no-data-text="Nenhuma localidade encontrada"
    :loading="localidLoading"
    v-model="localidSelecModel"
    :dense="dense"
    :disabled="disabled"
  >
  </v-autocomplete>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  props: {
    dense: Boolean,
    disabled: Boolean
  },
  computed: {
    ...mapState("locais", ["localidades", "localidSelec","localidLoading"]),
    localidSelecModel: {
      get: function () {
        return this.localidSelec;
      },
      set: function (value) {
        this.setLocalidSelec(value);
      },
    },
  },
  methods: {
    ...mapMutations("locais", ["setLocalidSelec"]),
  },
};
</script>

<style>
</style>